import { faFileExport, faPenToSquare, faQrcode } from '@fortawesome/free-solid-svg-icons'
import classes from './Actions.module.scss'
import WithdrawCertificateModal from '../../../../../shared/withdraw-certificate-modal/WithdrawCertificateModal'
import { useState } from 'react'
import { useSelector } from 'react-redux'
import useToastr from '../../../../../hooks/useToastr'
import { useDispatch } from 'react-redux'
import CertificateListService from '../../../../../services/CertificateListService'
import ProjectDetailsService from '../../../../../services/ProjectDetailsService'
import {
  updateProdDetailsAttachments,
  updateProdDetailsModelList,
  updateSelectedProjectDetails,
  updateModelList,
  updateCertificateScheme,
  updateLineDetails,
  updateOrderLineNumbers,
  updateSelectedOrderLineNumber,
  updateCertificateAction,
  updateServiceRequestNumber,
} from '../../../../../features/createCertificate/createCertificateSlice'
import AddNewCertificate from '../../add-new-certificate/AddNewCertificate'
import {
  reloadCertificateDetails,
  reloadCertificateList,
  selectActiveCertificateRow,
  updateIsLoadingCertificateList,
} from '../../../../../features/certificateList/certificateListSlice'
import CopyCertificateModal from '../../../../../shared/copy-certificate-modal/CopyCertificateModal'
import { flexProjectContactRole } from '../../../../../utils/constants/flex-project-contact-role.constants'
import { ConfirmDialog } from 'primereact/confirmdialog'
import { CertificateDocumentType } from '../../../../../enums/CertificateDocumentType'
import { CertificateDocumentStatus } from '../../../../../enums/CertificateDocumentStatus'
import { useTestReportValidator } from '../../add-new-certificate/test-report-matched-found-popup/useTestReportValidator'
import TestReportMatchedFoundPopup from '../../add-new-certificate/test-report-matched-found-popup/TestReportMatchedFoundPopup'
import {
  ecmUnavailableHeader,
  ecmUnavailableMessage,
} from '../../../../../utils/constants/ecm.constants'
import CertificateDetailsAttachmentsDialogV2 from '../certificate-details-attachments-dialog-v2/CertificateDetailsAttachmentsDialogV2'
import clsx from 'clsx'
import CertificateDetailsAttachmentsRPDialog from '../certificate-details-attachments-rp-dialog/CertificateDetailsAttachmentsRPDialog'
import { SchemeEcmType } from '../../../../../enums/SchemeEcmType'
import {
  CertificateGroupEnum,
  getAttributeUniqueName,
} from '../../../../../utils/constants/certificate.constants'
import useGenerateDocument from '../generate-document-modal/useGenerateDocument'
import GenerateDocumentModal from '../generate-document-modal/GenerateDocumentModal'
import ActionButton from './ActionButton'
import { useCertificateQrCodeGenerator } from '../../../hooks/useCertificateQrCodeGenerator'
const Actions = ({
  details,
  setDetails,
  setAttachments,
  setShowCertificateDetails,
  isReadOnly,
  onDeleteCertificate,
  inputAttachments,
  certificateDetailFromE2E,
  hasPendingTestReportFailedStatus,
  rpAttachments,
  setRPAttachments,
  isCOScheme = false,
  schemeEcmType,
}) => {
  const dispatch = useDispatch()
  const [isOpen, setIsOpen] = useState(false)
  const { showSuccess, showError, showWarning } = useToastr()
  const [isDisable, setIsDisable] = useState(false)
  const [displayAddNewCertModal, setDisplayAddNewCertModal] = useState(false)
  const [isModifyCert, setIsModifyCert] = useState(false)
  const [isOpenCopy, setIsOpenCopy] = useState(false)
  const [isOpenAttachment, setIsOpenAttachment] = useState(false)
  const [isOpenAttachmentRP, setIsOpenAttachmentRP] = useState(false)
  const [rpEditData, setRPEditData] = useState(null)
  const [revisionNumber, setRevisionNumber] = useState('')
  const [hasRevisionNumber, setHasRevisionNumber] = useState(false)
  const [modalHeader, setModalHeader] = useState(null)
  const [isConfirmDialogShow, setIsConfirmDialogShow] = useState(false)
  const [projectValues, setProjectValues] = useState(null)
  const [testReportValidationOutput, setTestReportValidationOutput] = useState(null)
  const activeCertificateRow = useSelector(selectActiveCertificateRow)
  const generateDocumentHook = useGenerateDocument(activeCertificateRow)
  const qrCodeGenerator = useCertificateQrCodeGenerator(activeCertificateRow)

  const isCO = certificateDetailFromE2E?.isCO ?? isCOScheme

  const testReportsValidatorHook = useTestReportValidator()

  const dialogFuncMap = {
    displayAddNewCertModal: setDisplayAddNewCertModal,
  }

  const onEdit = async () => {
    setIsModifyCert(false)
    setModalHeader({
      title: 'Edit Certificate',
      subTitle: "Continue working on a Certificate saved as 'Under Revision', or as a draft.",
    })
    dispatch(updateCertificateScheme(details.certificateScheme))
    await populateModels()
    dialogFuncMap['displayAddNewCertModal'](true)
  }

  const onModify = async () => {
    setIsDisable(true)
    if (hasPendingTestReportFailedStatus) return
    setIsModifyCert(true)
    setModalHeader({
      title: 'Modify Certificate',
      subTitle: 'Create a new revision of an existing certificate.',
    })
    dispatch(updateCertificateScheme(details.certificateScheme))
    await populateModels()
    dialogFuncMap['displayAddNewCertModal'](true)
    setIsDisable(false)
  }

  const onOpenWithdrawModal = async () => {
    dispatch(updateIsLoadingCertificateList(true))
    const result = await CertificateListService.getCertificateAttributes(
      details.certificateScheme,
      ''
    )
    dispatch(updateIsLoadingCertificateList(false))

    if (result[0]) {
      const certificateAttributes = result[0]['cert_attributes']

      if (certificateAttributes) {
        const revision = certificateAttributes.find(a => a.attribute_name === 'revisionNumber')

        if (revision) {
          setHasRevisionNumber(true)
        } else {
          setHasRevisionNumber(false)
        }
      }
    }
    setRevisionNumber(details.revisionNumber)
    setIsOpen(true)
  }

  const onWithdrawCertificate = async () => {
    setIsDisable(true)

    setIsModifyCert(true)
    dispatch(
      updateCertificateAction({
        isWithdraw: true,
      })
    )

    setModalHeader({
      title: 'Withdraw Certificate',
    })
    dispatch(updateCertificateScheme(details.certificateScheme))
    await populateModels()
    dialogFuncMap['displayAddNewCertModal'](true)
    setIsDisable(false)
  }

  const onOpenCopy = () => {
    setIsOpenCopy(true)
  }

  const onAttach = async () => {
    setIsDisable(true)
    dispatch(updateCertificateScheme(details.certificateScheme))

    await populateModels()
    await fetchFormValuesForRP()

    if (schemeEcmType && schemeEcmType === SchemeEcmType.RP) {
      setIsOpenAttachmentRP(true)
    } else {
      setIsOpenAttachment(true)
    }

    setIsDisable(false)
  }

  const fetchFormValuesForRP = async () => {
    const editData = details?.editData
    const standardAttributeName = getAttributeUniqueName(
      CertificateGroupEnum.Certificate,
      'standard'
    )

    const issueDateAttributeName = getAttributeUniqueName(CertificateGroupEnum.Certify, 'issueDate')

    const referenceAttributeName = getAttributeUniqueName(
      CertificateGroupEnum.Certificate,
      'testReportNumber'
    )

    const certificateNameAttributeName = getAttributeUniqueName(
      CertificateGroupEnum.Certificate,
      'certificateName'
    )

    const revisionNumberAttributeName = getAttributeUniqueName(
      CertificateGroupEnum.Certificate,
      'revisionNumber'
    )

    const revisionDateAttributeName = getAttributeUniqueName(
      CertificateGroupEnum.Certify,
      'revisionDate'
    )

    const certificateSchemeAttributeName = getAttributeUniqueName(
      CertificateGroupEnum.Certificate,
      'certificateType'
    )

    let certificateNumber = ''
    let certificateScheme = ''
    let issueDate = null
    let revisionDate = null
    let referenceNumber = null
    let standardValue = ''
    let revisionNumber = ''

    for (const data of editData) {
      switch (data?.attribute_unique_name) {
        case certificateNameAttributeName: {
          certificateNumber = data?.value[0]
          break
        }
        case revisionNumberAttributeName: {
          revisionNumber = data?.value[0]
          break
        }
        case referenceAttributeName: {
          referenceNumber = data?.value?.join(', ')
          break
        }
        case issueDateAttributeName: {
          issueDate = data?.value ? data?.value[0] : null
          break
        }
        case revisionDateAttributeName: {
          revisionDate = data?.value ? data?.value[0] : null
          break
        }
        case certificateSchemeAttributeName: {
          certificateScheme = data?.value[0]
          break
        }
        case standardAttributeName:
          {
            let standardValueArray = []
            const filterProdType = editData?.filter(
              editDT =>
                editDT.attribute_unique_name ===
                getAttributeUniqueName(CertificateGroupEnum.Certificate, 'certificationProductType')
            )

            if (filterProdType.length > 0) {
              const standardsList = await CertificateListService.getIpAttributesDropdownList(
                'standard',
                filterProdType[0].value[0]
              )

              if (standardsList && standardsList.length > 0) {
                for (const standardValue of data?.value) {
                  const getStandardValueText = standardsList.find(
                    standard => standard.code === standardValue
                  )
                  if (getStandardValueText) standardValueArray.push(getStandardValueText.name)
                }
              }
            }

            standardValue = standardValueArray.join(', ')
          }
          break
        default: {
          break
        }
      }
    }

    setRPEditData({
      certificateNumber: certificateNumber,
      certificateScheme: certificateScheme,
      revisionNumber: revisionNumber,
      issueDate: issueDate,
      revisionDate: revisionDate,
      referenceNumber: referenceNumber,
      standardNumber: standardValue,
    })
  }

  const proceedActivationWithDuplicate = async () => {
    testReportsValidatorHook.setTestReportMatchedFoundPopupVisible(false)
    await activateCertificate()
  }

  const onCancelActivation = async () => {
    testReportsValidatorHook.setTestReportMatchedFoundPopupVisible(false)
    setIsDisable(false)
  }

  const validateTestReport = async () => {
    const testReportsAttachments = inputAttachments
      .filter(
        attachment =>
          attachment.documentType === CertificateDocumentType.TestReport &&
          (attachment.status === CertificateDocumentStatus.ReadyToLinkToWbAndEcmTic ||
            attachment.status === CertificateDocumentStatus.TestReportDuplicate)
      )
      .map(file => file.originalFileName)

    const baseModel = details.linkedProducts[0].modelName
    const certificateType = details.certificateScheme
    const ownerReference = details.editData.find(psn => psn.attribute_name === 'ownerReference')
      ?.value[0]

    if (!testReportsAttachments) return

    const validationResult = await testReportsValidatorHook.validateTestReports(
      testReportsAttachments,
      ownerReference,
      certificateType,
      baseModel
    )

    if (validationResult.hasDuplicate) {
      testReportsValidatorHook.setTestReportMatchedFoundPopupVisible(true)
      setTestReportValidationOutput(validationResult.matchedTestReports)
    } else {
      await activateCertificate()
    }
  }

  const onActivate = async disabled => {
    if (disabled) return

    setIsDisable(true)

    if (details.certificateStatus != 'Under Revision') return

    const certDetailsResp = await CertificateListService.getCertificateDetailsForActivation(
      details.certificateId
    )

    if (!certDetailsResp.isSuccess) return

    let certDetails = certDetailsResp.data

    if (!certDetails || certDetails.certificateStatus != 'Under Revision') return

    if (certDetails.hasValidAttachments && certDetails.hasBaseModel) {
      setIsConfirmDialogShow(true)
    } else {
      await activateCertificate()
    }
  }

  const activateCertificate = async () => {
    const response = await CertificateListService.activateCertificate({
      certificateId: details.certificateId,
      projectNumber: details.projectNumber,
    })

    if (response.isSuccess) {
      await processCertificateDetailsUpdate()
    } else {
      showError('Error!', response.message)
    }

    setIsDisable(false)
  }

  const processCertificateDetailsUpdate = async () => {
    const result = await CertificateListService.updateActivatedCertificateDetails(
      details.certificateId
    )
    showSuccess('Success!', 'Certificate activated successfully')
    dispatch(reloadCertificateList(true))
    dispatch(reloadCertificateDetails(true))

    if (!result.isSuccess) {
      showWarning(ecmUnavailableHeader, ecmUnavailableMessage)
    }
  }

  const populateModels = async () => {
    let prevDetails = JSON.parse(JSON.stringify(details))
    if (certificateDetailFromE2E?.baseModel) {
      prevDetails.assets.forEach(asset => {
        if (asset.modelName == certificateDetailFromE2E.baseModel) {
          asset.isBaseModel = true
          return
        }
      })
      setDetails(prevDetails)
    }
    dispatch(updateProdDetailsModelList(prevDetails.assets))
    dispatch(updateModelList(prevDetails.assets))

    const isServiceRequestNumber = details?.certificateDetails?.isServiceRequestNumber
    const requestNumber = isServiceRequestNumber
      ? details?.certificateDetails?.serviceRequestNumber
      : details?.projectNumber

    await populateProjectDetails(
      requestNumber,
      details?.localData?.line_number,
      isServiceRequestNumber
    )
  }

  const populateProjectDetails = async (
    serviceNumber,
    lineNumber,
    isServiceRequestNumber = false
  ) => {
    const requestNumberEndpoint = isServiceRequestNumber
      ? ProjectDetailsService.getProjectSuggestionsByServiceRequestNumber
      : ProjectDetailsService.getProjectSuggestions

    const projectDetailEndpoint = isServiceRequestNumber
      ? ProjectDetailsService.getProjectDetailByServiceRequestNumber
      : ProjectDetailsService.getProjectDetail

    const requestNumbers = await requestNumberEndpoint(serviceNumber)
    if (requestNumbers.length === 0) return

    let updatedSelectedProjectDetails

    const item = requestNumbers[0]
    const projectNumber = isServiceRequestNumber
      ? item?.service_Request_Number
      : item?.project_Number

    const data = await projectDetailEndpoint(projectNumber)

    if (isServiceRequestNumber) {
      const project = data.value[0]

      dispatch(updateSelectedProjectDetails(project))
      dispatch(updateServiceRequestNumber(project?.serviceRequestNumber))
      setProjectValues(project)
    } else {
      let tempLineDetails = []
      data.value.forEach(d => {
        //Filter - Get Child Lines
        let lineDatas = d.projectServiceLines.filter(l => l.lineNumber.split('.').length === 3)

        if (lineDatas.length === 0) {
          lineDatas = d.projectServiceLines.filter(l => l.lineNumber == l.parentLineNumber)
        }

        for (var i = 0; i < lineDatas.length; i++) {
          const projectContacts = getProjectContact(d.projectContacts)

          lineDatas[i].partySiteNumber = projectContacts.partySiteNumber
          lineDatas[i].companyId = d.companyId
          lineDatas[i].address = projectContacts.address
          lineDatas[i].city = projectContacts.city
          lineDatas[i].state = projectContacts.state
          lineDatas[i].province = projectContacts.province
          lineDatas[i].country = projectContacts.country
          lineDatas[i].postalcode = projectContacts.postalCode
          lineDatas[i].partysite = projectContacts.partySiteNumber
          lineDatas[i].customer = d.companyName
          lineDatas[i].poc = projectContacts.country
          lineDatas[i].handlerName = d.projectHandler
          lineDatas[i].fulfillmentLocation = item.preferred_Fulfillment_Location
          lineDatas[i].projectFlexId = d.projectId
          lineDatas[i].projectNumber = d.projectNumber
          lineDatas[i].orderNumber = d.orderNumber
          lineDatas[i].quoteNo = d.quoteNo
          lineDatas[i].projectName = d.name
        }

        tempLineDetails = tempLineDetails.concat(lineDatas)
      })
      tempLineDetails = tempLineDetails.filter(l => l != null)

      const lineNumbers = tempLineDetails.map(d => d.lineNumber)
      const sortedLineNumbers = lineNumbers
        .map(a =>
          a
            .split('.')
            .map(n => +n + 100000)
            .join('.')
        )
        .sort()
        .map(a =>
          a
            .split('.')
            .map(n => +n - 100000)
            .join('.')
        )

      const mappedLines = sortedLineNumbers.map(d => {
        var details = tempLineDetails.find(l => l.lineNumber === d)
        return {
          name: (details?.isCpq ? details?.parentLineNumber : d) + ' - ' + details?.projectName,
          value: d,
        }
      })

      const selectedProjectDetails = tempLineDetails.find(t => t.lineNumber === lineNumber)

      if (selectedProjectDetails) {
        updatedSelectedProjectDetails = await getUserDetails(selectedProjectDetails)
      } else {
        const tempLineDetailData = tempLineDetails.find(
          line => line.lineNumber === mappedLines[0].value
        )

        updatedSelectedProjectDetails = await getUserDetails(tempLineDetailData)
      }

      await getServiceLine(updatedSelectedProjectDetails)

      dispatch(updateLineDetails(tempLineDetails))
      dispatch(updateOrderLineNumbers(mappedLines))
      dispatch(updateSelectedProjectDetails(updatedSelectedProjectDetails))
      dispatch(updateSelectedOrderLineNumber(lineNumber ?? mappedLines[0].value))

      setProjectValues(updatedSelectedProjectDetails)
    }
  }

  const getServiceLine = async selectedDetailsToUpdate => {
    const result = await ProjectDetailsService.getServiceLine(selectedDetailsToUpdate.projectId)

    selectedDetailsToUpdate.serviceLine = result.service_Line
  }

  const getUserDetails = async selectedProjectDetails => {
    if (!selectedProjectDetails || !selectedProjectDetails.handlerName)
      return selectedProjectDetails

    const response = await ProjectDetailsService.getUserDetails(selectedProjectDetails.handlerName)

    if (!response) return selectedProjectDetails

    const handlerCountry = response.split('-')[0]
    const handlerLocation = response.split('-')[1]

    selectedProjectDetails.handlerCountry = handlerCountry
    selectedProjectDetails.handlerLocation = handlerLocation
    return selectedProjectDetails
  }

  const isCertificateActive = details?.certificateStatus === 'Active'
  const isCertificateUnderRevision = details?.certificateStatus === 'Under Revision'
  const isCertificateWithdrawnOrObsolete =
    details?.certificateStatus === 'Withdrawn' || details?.certificateStatus === 'Obsolete'

  const actions = [
    {
      label: 'Edit',
      onClick: onEdit,
      faIcon: faPenToSquare,
      isVisible: isCertificateUnderRevision,
    },
    {
      label: 'Modify',
      disabled: hasPendingTestReportFailedStatus,
      materialIcon: 'auto_fix_normal',
      onClick: onModify,
      isVisible: isCertificateActive,
    },
    {
      label: 'Create Copy',
      onClick: onOpenCopy,
      materialIcon: 'file_copy',
      isVisible:
        isCertificateActive || isCertificateUnderRevision || isCertificateWithdrawnOrObsolete,
    },
    {
      label: 'Withdraw',
      onClick: onWithdrawCertificate,
      materialIcon: 'archive',
      isVisible: isCertificateActive,
    },
    {
      label: 'Delete',
      onClick: () => onDeleteCertificate(details),
      materialIcon: 'delete',
      isVisible: isCertificateUnderRevision && !isReadOnly,
    },
    {
      label: 'Attach',
      onClick: onAttach,
      materialIcon: 'attach_file',
      isVisible: isCertificateUnderRevision || isCertificateActive,
    },
    {
      label: 'Generate Document',
      onClick: () => generateDocumentHook.show(),
      faIcon: faFileExport,
      isVisible: isCertificateUnderRevision || isCertificateActive,
    },
    {
      label: 'Generate QR Code',
      onClick: () => qrCodeGenerator.downloadZip(),
      faIcon: faQrcode,
      isVisible: qrCodeGenerator.isSchemeSupported,
      disabled: qrCodeGenerator.isDisabled,
    },
    {
      label: 'Open Certificate in Workbench',
      onClick: () =>
        window.open(
          `${process.env.REACT_APP_WORKBENCH_CERTIFICATION_URL}/certification/details?id=${details.certificateId}`,
          '_blank'
        ),
      materialIcon: 'open_in_new',
      isVisible: isCertificateUnderRevision || isCertificateActive,
    },
  ].filter(action => action.isVisible)

  const handleCloseAttachmentsDialog = () => {
    setIsOpenAttachment(false)

    dispatch(updateSelectedProjectDetails(null))
  }

  const getProjectContact = projectContacts => {
    const soldTo = projectContacts.find(pc => pc.contactRoleId === flexProjectContactRole.SoldTo)
    if (soldTo?.partySiteNumber) return soldTo

    const shipTo = projectContacts.find(pc => pc.contactRoleId === flexProjectContactRole.ShipTo)
    if (shipTo?.partySiteNumber) return shipTo

    const customer = projectContacts.find(
      pc => pc.contactRoleId === flexProjectContactRole.Customer
    )
    if (customer?.partySiteNumber) return customer

    const billTo = projectContacts.find(pc => pc.contactRoleId === flexProjectContactRole.BillTo)
    if (billTo?.partySiteNumber) return billTo
  }

  const confirmDialogBody = () => {
    return (
      <>
        <div className="custom-confirm-dialog-body">
          <div className="custom-space-below">
            File(s) will be saved to ECM TIC and cannot be deleted.
          </div>
          <div>Would you like to Continue?</div>
        </div>
      </>
    )
  }

  const confirmFooter = () => {
    return (
      <>
        <div className="custom-confirm-dialog-footer">
          <button
            className="ul-button -app-primary -medium custom-confirm-dialog-accept-btn"
            onClick={acceptConfirmDialog}
          >
            YES
          </button>
          <button
            className="ul-button -medium default-cancel-button custom-confirm-dialog-reject-btn"
            onClick={rejectConfirmDialog}
          >
            NO
          </button>
        </div>
      </>
    )
  }

  const acceptConfirmDialog = async () => {
    setIsConfirmDialogShow(false)
    await validateTestReport()
  }

  const rejectConfirmDialog = () => {
    setIsConfirmDialogShow(false)
    setIsDisable(false)
  }

  return (
    <>
      <AddNewCertificate
        dialogFuncMap={dialogFuncMap}
        displayAddNewCertModal={displayAddNewCertModal}
        isEditCert={true}
        certificateId={details.certificateId}
        certificateScheme={details?.certificateScheme}
        hierarchyId={details.hierarchyId}
        revisionNumber={details.revisionNumber}
        editData={details.editData}
        localData={details.localData}
        certificateStatus={details.certificateStatus}
        hasRevisions={details?.revisionHistory?.length > 0}
        setShowCertificateDetails={setShowCertificateDetails}
        isModifyCert={isModifyCert}
        setIsModifyCert={setIsModifyCert}
        customModalHeader={
          Boolean(modalHeader) ? (
            <>
              <div>{modalHeader.title}</div>
              <small
                style={{
                  fontWeight: 'normal',
                }}
              >
                {modalHeader.subTitle}
              </small>
            </>
          ) : undefined
        }
        inputAttachments={inputAttachments}
        setAttachments={setAttachments}
        rpAttachments={rpAttachments}
        setRPAttachments={setRPAttachments}
        uniqueCertificateId={details?.uniqueCertificateId}
      />
      <WithdrawCertificateModal
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        certificateId={details.certificateId}
        hasRevisionNumber={hasRevisionNumber}
        revisionNumber={revisionNumber}
      />
      <CopyCertificateModal
        isOpen={isOpenCopy}
        setIsOpen={setIsOpenCopy}
        details={details}
        setShowCertificateDetails={setShowCertificateDetails}
      />

      {schemeEcmType && schemeEcmType === SchemeEcmType.RP && (
        <CertificateDetailsAttachmentsRPDialog
          isOpen={isOpenAttachmentRP}
          setIsOpen={setIsOpenAttachmentRP}
          details={details}
          rpAttachments={rpAttachments}
          setRPAttachments={setRPAttachments}
          projectDetailsValues={projectValues}
          certificateDetailsFromE2E={certificateDetailFromE2E}
          fromEditData={rpEditData}
        />
      )}

      {(!schemeEcmType || (schemeEcmType && schemeEcmType === SchemeEcmType.GMA)) && (
        <CertificateDetailsAttachmentsDialogV2
          certificateId={details.certificateId}
          setAttachments={setAttachments}
          isOpen={isOpenAttachment}
          onClose={handleCloseAttachmentsDialog}
          details={details}
          inputAttachments={inputAttachments}
          certificateDetailFromE2E={certificateDetailFromE2E}
        />
      )}
      <div className="flex gap-3 w-full max-w-full my-1">
        {actions.map(action => (
          <ActionButton
            className={clsx(
              classes.action,
              'grow',
              actions.length > 4 ? 'max-w-[140px]' : 'max-w-fit',
              {
                [classes.disable]: isDisable || action.disabled,
                [classes.active]: !isDisable && !action.disabled,
                ['text-[.8rem]']: actions.length > 4,
              }
            )}
            key={action.label}
            label={action.label}
            onClick={action.onClick}
            faIcon={action.faIcon}
            materialIcon={action.materialIcon}
            title={action.title}
          />
        ))}
      </div>
      <hr className={clsx(classes.line, 'my-3')} />
      <ConfirmDialog
        style={{ width: '520px' }}
        className="custom-confirm-dialog"
        visible={isConfirmDialogShow}
        header="Save and Activate Confirmation"
        message={confirmDialogBody}
        footer={confirmFooter}
        onHide={() => rejectConfirmDialog()}
      />
      <TestReportMatchedFoundPopup
        visible={testReportsValidatorHook.testReportMatchedFoundPopupVisible}
        onProceedWithoutDuplicate={onCancelActivation}
        onProceedWithDuplicate={() => {
          proceedActivationWithDuplicate()
        }}
        onClose={onCancelActivation}
        rows={testReportValidationOutput}
      />
      <GenerateDocumentModal hook={generateDocumentHook} />
    </>
  )
}

export default Actions
